<template>
  <div class="card-form">
    <EditForm
      ref="editForm"
      :disabled="disabled"
      :amzReplenishmentCode="amzReplenishmentCode"
    />
    <div
      class="d-flex justify-content-end mb-2 mt-2"
      v-if="pageType === 'confirm'"
    >
      <el-button type="primary" size="small" @click="$refs.editForm.confirm()"
        >{{ $l('btn_confirmReplenishment') || '确认补货' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsBiz-operateReplyConfirm-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    amzReplenishmentCode() {
      return this.params.amzReplenishmentCode
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
